import { createGlobalStyle } from 'styled-components';

export const macOSTheme = {
  colors: {
    background: '#ffffff',
    sidebar: '#f5f5f7',
    primary: '#0071e3',
    secondary: '#86868b',
    text: '#1d1d1f',
    border: '#d2d2d7',
    error: '#ff3b30',
    success: '#34c759',
    highlight: '#f5f5f7'
  },
  fonts: {
    system: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.12)',
    large: '0 8px 16px rgba(0, 0, 0, 0.14)'
  },
  borderRadius: '8px'
};

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: ${props => props.theme.fonts.system};
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    line-height: 1.5;
  }

  .app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .content {
    flex-grow: 1;
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
  }

  button {
    background-color: ${props => props.theme.colors.primary};
    color: white;
    border: none;
    border-radius: ${props => props.theme.borderRadius};
    padding: 8px 16px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #0062c1;
    }

    &:active {
      background-color: #005bb5;
    }

    &:disabled {
      background-color: #a1a1a6;
      cursor: not-allowed;
    }
  }

  input, select, textarea {
    font-family: ${props => props.theme.fonts.system};
    border: 1px solid ${props => props.theme.colors.border};
    border-radius: ${props => props.theme.borderRadius};
    padding: 8px 12px;
    font-size: 14px;
    transition: border-color 0.2s;

    &:focus {
      outline: none;
      border-color: ${props => props.theme.colors.primary};
    }
  }

  .card {
    background-color: white;
    border-radius: ${props => props.theme.borderRadius};
    box-shadow: ${props => props.theme.shadows.small};
    padding: 20px;
    margin-bottom: 20px;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;
  }

  @media (max-width: 768px) {
    .content {
      padding: 15px;
    }
    
    .grid {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      gap: 15px;
    }
  }

  @media (max-width: 480px) {
    button {
      padding: 8px 12px;
      font-size: 14px;
    }
    
    .grid {
      grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
      gap: 10px;
    }
    
    .card {
      padding: 15px;
    }
  }
`;